module.exports = {
        // 服务平台-注册
        ServiceRegister:'https://192.168.0.198:30877/#/register',
        // 服务平台
        ServicePlatform:'https://192.168.0.198:30877',
        // 直采商城业务系统
        Mall:'https://192.168.0.193:3000',
        // 专家管理系统
        ExpertReview:'httpss://ebidding.hh.s-test.site',
}